__turbopack_context__.v({
  "key": "GJLScW_key",
  "keyIcon": "GJLScW_keyIcon",
  "keyName": "GJLScW_keyName",
  "keyWord": "GJLScW_keyWord",
  "plus": "GJLScW_plus",
  "shortcut": "GJLScW_shortcut",
});
